<template>
  <core-view>
    <div>
      <!-- Espaço para futuros filtros globais, se necessário -->
    </div>

    <component :is="componenteAtivo" :produto="produto" />

  </core-view>
</template>

<script>
import CoreView from '@/components/core/view/Index.vue';
import Sugestao from '@/components/app/card/filtroproduto/sugestao/Index.vue';
import Detalhamento from '@/components/app/card/filtroproduto/detalhamento/Index.vue';

export default {
  name: 'ViewFiltroProduto',

  components: {
    CoreView,
    Sugestao,
    Detalhamento,
  },

  data() {
    return {
      filtroAtivo: null,
      produto: { nome: '', codigo: '', idGrupo: null, imagens: [] },
    };
  },

  watch: {
    '$route.query': {
      immediate: true,
      handler(query) {

        this.produto = {
          nome: query.produtoNome || '',
          codigo: query.produtoCodigo || '',
          idGrupo: query.idGrupo ? parseInt(query.idGrupo) : null,
          imagens: [],
        };
        
        this.filtroAtivo = query.aba || 'sugestao';
      }
    }
  },

  computed: {
    componenteAtivo() {
      const componentes = {
        sugestao: 'Sugestao',
        detalhamento: 'Detalhamento',
      };
      return componentes[this.filtroAtivo] || 'Sugestao';
    },
  },
};
</script>
<style scoped>
.linha_botoes {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}

.btn {
  width: auto;
  min-width: 0px !important;
  padding: 0 1.5vw 0 1.5vw  !important;
}

@media screen and (max-width: 375px) {
  .btn {
    margin: 3px !important;
    margin-bottom: 8px !important;
  }
}

.center-text {
  display: flex;
  justify-content: center;
}

.ultimo {
  justify-self: right;
}

</style>
